import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface Props {
  children: ReactNode
}

interface State {
  error: Error | null
}

export class RootErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Root render error:', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-app-bg px-4 text-text-primary">
          <h1 className="text-lg font-semibold">Something went wrong</h1>
          <p className="max-w-md text-center text-sm text-text-secondary">
            {this.state.error.message}
          </p>
          <Link
            to="/"
            className="text-sm text-accent hover:underline"
            onClick={() => this.setState({ error: null })}
          >
            Reload home
          </Link>
        </div>
      )
    }

    return this.props.children
  }
}
